export const opuSearchFormDefaultValues = {
  dishType: '1',
  ivmTechTime: '',
  gradeABC: 0,
  gradeD: 0,
  gradeE: 0,
  dead: 0,
  total: 0,
  numInMat: 0,
  comments: '',
  fertPlan: '',
  usdaSeal: '',
  ivmCyto: 100000001,
};
